import React, { FunctionComponent } from "react";
import { Grid } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import cs from "classnames";
import { useTranslation } from "react-i18next";
import { LocationDistanceTableRecord } from "/src/domain/challenges/ChallengeProtocolData";
import { theme } from "/src/assets/theme";

export type LocationDistanceRecordViewProps = {
    className?: string,
    record: LocationDistanceTableRecord,
    place: number
};

export const LocationDistanceRecordView: FunctionComponent<LocationDistanceRecordViewProps> = ({ className, record, place }) => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <div className={cs(className, classes.container)}>
            <Grid
                container
                className={cs(classes.tableContainer)}
                alignItems="center"
                justifyContent="center"
            >
                <Grid item container xs={11} spacing={1}>
                    <Grid item xs={1} ></Grid>
                    <Grid item xs={1} container justifyContent="center" style={{ paddingLeft: 0 }} className={classes.cell}>
                        {place}
                    </Grid>
                    <Grid item xs={6} className={classes.cell}>
                        {record.location}
                    </Grid>
                    <Grid item container xs={4} justifyContent="flex-end" className={classes.cell}>
                        {record.result / 1000}
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
};

const useStyles = makeStyles({
    container: {
        color: theme.primaryColor,
        '&:nth-child(odd)': {
            backgroundColor: theme.lightPrimaryColor
        },
    },
    cell: {
        overflowX: 'auto',
    },
    tableContainer: {
        width: '100%',
        margin: 0,
        fontSize: '0.9rem',
        fontWeight: 500,
        padding: '0.5rem 0',
    },
    currentUser: {
        backgroundColor: theme.primaryCurrentUserColor
    },
    info: {
        marginTop: '0.2rem',
        fontSize: '0.75rem',
        '&>div': {
            padding: '0.2rem 0',
        }
    }
})